// extracted by mini-css-extract-plugin
export default {"vkButton":"ButtonVk_vkButton__3OZHj"};